/*
 * Copyright (c) 2020. American Express Company
 */

import { Board } from 'src/bw/board/Board';

import NavigationService from '../../services/navigation.service';
import LiteralsService from '../../services/literals/LiteralsService';

export default class DrawerFactory {
    private readonly component: Board;
    private loaderTimeout: number;

    constructor(component: any) {
        this.component = component;
    }

    public handleTopDrawer(): void {
        void NavigationService.goTo(this.component.props.history, '/', 'Top Drawer');
    }

    public showLoader(msg: string | string[] = [LiteralsService.getLiteral('Loader.accountLine1')]): void {
        if (this.loaderTimeout) return;

        this.loaderTimeout = window.setTimeout(() => {
            this.component.setState({
                waitMessages: Array.isArray(msg) ? msg : [msg]
            });
        }, 2500);
    }

    public hideLoader(): void {
        window.clearTimeout(this.loaderTimeout);
        this.component.setState({
            waitMessages: []
        });
        this.loaderTimeout = undefined;
    }

    /**
     * Warning: Avoid using this directly. This is for our router to use.
     * @param value
     * @param props
     */
    public setDrawerRoute(value: string, props: any = {}): void {
        if (!props.handleBack) {
            props.handleBack = this.defaultHandleBack(value);
        }
        props.previousState = this.component.state.drawerState;

        const drawerProps: any = this.component.state.drawerProps;
        if (drawerProps.transactionsChanged || drawerProps.incomeChanged) {
            // if something changed, don't switch until we've reloaded the new user data
            void this.component.handleReloadUser().then(() => this.setNewDrawerRouteState(value, props));
        } else {
            this.setNewDrawerRouteState(value, props);
        }
    }

    public setNewDrawerRouteState(value: string, props: any = {}): void {
        this.component.setState({
            drawerState: value,
            drawerProps: props
        });
    }

    public updateDrawer(props: any): void {
        this.component.setState({
            drawerProps: props
        });
    }

    public handleBack(): void {
        if (this.component.state.drawerProps.handleBack) {
            this.component.state.drawerProps.handleBack();
        } else {
            if (this.component.props.history) {
                void NavigationService.goBack(this.component.props.history);
            } else {
                this.handleTopDrawer();
            }
        }
    }

    public defaultHandleBack(drawer: string): any {
        let handleBack: any;

        switch (drawer) {
            case 'account':
                handleBack = () => {
                    void this.component.handleAccounts();
                };
                break;
            case 'add-accounts':
                handleBack = () => {
                    void NavigationService.goBack(this.component.props.history);
                };
                break;
            case 'debt':
                handleBack = () => {
                    void this.component.handleAccounts();
                };
                break;
            case 'expense':
                handleBack = () => {
                    void NavigationService.goTo(
                        this.component.props.history,
                        '/drawer/zero-expenses',
                        'Zero Expenses' + ' drawer'
                    );
                };
                break;
            case 'income-details':
                handleBack = () => {
                    void NavigationService.goTo(this.component.props.history, '/drawer/incomes', 'Incomes drawer');
                };
                break;
            case 'income':
                handleBack = () => {
                    void NavigationService.goTo(this.component.props.history, '/drawer/incomes', 'Incomes drawer');
                };
                break;
            case 'investment':
                handleBack = () => {
                    void this.component.handleAccounts();
                };
                break;
            default:
                handleBack = this.handleTopDrawer.bind(this);
                break;
        }

        return handleBack;
    }
}
